import { Component, OnInit } from '@angular/core';
import { LoanappService } from 'app/services/loanapp.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-loan-agreementforbank',
  templateUrl: './loan-agreementforbank.component.html',
  styleUrls: ['./loan-agreementforbank.component.css'],
})
export class LoanAgreementforbankComponent implements OnInit {
  accepted: Boolean = false;
  btnClicked: Boolean = false;
  appId = String;
  appIdFound: Boolean = false;
  otpVerified: Boolean = false;
  otpSent: Boolean = false;
  phoneNo: String = '';
  signInClicked: Boolean = false;
  otp: String;
  errMsg: string = 'Please wait..';
  appDetails: any;
  dApp: any;
  dataLoading: Boolean = false;

  constructor(
    private lapp: LoanappService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.appId = params['appId'];
      if (this.appId) {
        this.appIdFound = true;
        console.log('App ID found.');
      }
    });
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.lapp.sanctionConsentD(this.appId).subscribe(
      (data) => {
        if (data['success']) {
          this.appDetails = data['data'][0];
          this.dApp = data['dApp'];
          this.dataLoading = true;
        }
      },
      (err) => {
        console.log(err);
        this.toastr.error('Something went wrong. Please try again later.');
      }
    );
  }

  convertNoToWords(n) {
    var a = [
      '',
      'एक ',
      'दोन ',
      'तीन ',
      'चार ',
      'पाच ',
      'सहा ',
      'सात ',
      'आठ ',
      'नऊ ',
      'दहा ',
      'अकरा ',
      'बारा ',
      'तेरा ',
      'चौदा ',
      'पंधरा ',
      'सोळा ',
      'सतरा ',
      'अठरा ',
      'एकोणविस ',
    ];
    var b = [
      '',
      '',
      'वीस',
      'तीस',
      'चाळीस',
      'पन्नास',
      'साठ',
      'सत्तर',
      'अंशी',
      'नव्वद',
    ];

    if ((n = n.toString()).length > 9) return 'overflow';
    n = ('000000000' + n)
      .substr(-9)
      .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return;
    var str = '';
    str +=
      n[1] != 0
        ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'करोड '
        : '';
    str +=
      n[2] != 0
        ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'लाख '
        : '';
    str +=
      n[3] != 0
        ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'हजार '
        : '';
    str +=
      n[4] != 0
        ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'शंभर '
        : '';
    str +=
      n[5] != 0
        ? (str != '' ? 'and ' : '') +
          (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) +
          'फक्त '
        : '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  numberWithCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
    // return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  newDate() {
    if (this.appDetails['loanAgreementAcceptanceTimestamp']) {
      return this.appDetails['loanAgreementAcceptanceTimestamp'];
    } else {
      return new Date();
    }
  }
}
